import {useTranslation} from 'react-i18next';
export const useTournamentFieldConfig = (): Record<
    string,
    {
        min?: number;
        max?: number;
        displayName?: string;
        step?: number;
        description?: string;
        cannotChangeAfterCreation?: boolean;
        type?: 'select' | 'number';
    }
> => {
    const {t} = useTranslation();
    return {
        baseLevel: {
            type: 'select',
            cannotChangeAfterCreation: true,
            description: t('tournaments.base_level_description'),
        },
        maxLevel: {
            type: 'select',
            cannotChangeAfterCreation: true,
            description: t('tournaments.max_level_description'),
        },
        problemsCount: {
            min: 10,
            max: 100,
            step: 1,
            cannotChangeAfterCreation: true,
            description: t('tournaments.problems_count_description'),
            type: 'number',
        },
        step: {
            min: 1,
            max: 5,
            step: 1,
            description: t('tournaments.step_description'),
            cannotChangeAfterCreation: true,
            type: 'number',
        },
        threshold: {
            min: 1,
            max: 5,
            step: 1,
            displayName: t('tournaments.threshold_display_name'),
            description: t('tournaments.threshold_description'),
            cannotChangeAfterCreation: true,
            type: 'number',
        },
        exponent: {
            min: 0,
            max: 1,
            step: 0.01,
            displayName: t('tournaments.exponent_display_name'),
            description: t('tournaments.exponent_description'),
            type: 'number',
        },
        roundDuration: {
            min: 30,
            max: 300,
            step: 1,
            displayName: t('tournaments.round_duration_display_name'),
            type: 'number',
        },
        pauseBetweenRounds: {
            min: 10,
            max: 120,
            step: 1,
            displayName: t('tournaments.pause_between_rounds_display_name'),
            type: 'number',
        },
        minimalPlayersCount: {
            min: 2,
            max: 100,
            step: 1,
            description: t('tournaments.minimal_players_count_description'),
            type: 'number',
        },
        lives: {
            min: 1,
            max: 5,
            step: 1,
            type: 'number',
        },
        gobits: {
            min: 0,
            max: 500,
            step: 1,
            description: t('tournaments.gobits_description'),
            cannotChangeAfterCreation: true,
            type: 'number',
        },
    };
};
